import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import { Dropdown } from 'primereact/dropdown'
import Backdrop from '@mui/material/Backdrop';
import { Checkbox } from 'primereact/checkbox'
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import { Badge } from 'primereact/badge';


import NavBar from '../../componentes/Navbar'

import GrupoAtividadeService from '../../app/service/GrupoAtividadeService';
import GrupoAtividadeTituloService from '../../app/service/GrupoAtividadeTituloService';
import TituloAtividadeService from '../../app/service/TituloAtividadeService';
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService';
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService';
import RodizioUsuarioService from '../../app/service/RodizioUsuarioService';

class GrupoAtividade extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			openSpinner: false,
			grupo: null,
			nome: '',
			codigo: '',
			grupos: [],
			modalGrupo: false,
			modalGrupoAlterar: false,
			//Títulos
			atividadeGrupoTitulo: null,
			titulo: null,
			tituloNome: '',
			tituloExcluir: null,
			titulos: [],
			titulosCombo: [],
			modalTitulos: false,
			prazo: '',
			prazoFatal: '',
			prazoEditar: '',
			prazoFatalEditar: '',
			flags: ['N', 'N', 'N'], // Array para armazenar S ou N para Importante, Urgente, Privado
			flagsEditar: ['N', 'N', 'N'], // Array para armazenar S ou N para Importante, Urgente, Privado
			modalEditarTitulo: false,
			//Preparação para o Rodízio
			grupoTitulo: null,
			gruposTrabalhoCombo: [],
			grupoTrabalho: null,
			subGrupoTrabalhoCombo: [],
			subGruposUsuarios: {},
			usuarios: [],
			usuario: null,
			usuarioExcluir: null,
			modalNovoRodizio: false,
			//Rodízio
			usuariosRodizio: [],
			modalRodizio: false,
			modalEditarRodizio: false,
			rodizio: null,
			rodizioNumero: '',
			usuarioNome: ''
		}

		this.grupoAtividadeService = new GrupoAtividadeService();
		this.grupoAtividadeTituloService = new GrupoAtividadeTituloService();
		this.tituloAtividadeService = new TituloAtividadeService();
		this.grupoTrabalhoService = new GrupoTrabalhoService();
		this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
		this.rodizioService = new RodizioUsuarioService();

		this.renderFooterAlterarGrupo = this.renderFooterAlterarGrupo.bind(this);
		this.acoes = this.acoes.bind(this);
		this.acoesTitulos = this.acoesTitulos.bind(this);
		this.onChangeGrupoTrabalho = this.onChangeGrupoTrabalho.bind(this);
		this.acoesRodizioUsuarios = this.acoesRodizioUsuarios.bind(this);
	}

	novoTitulo = async (grupo) => {
		this.setState({titulo: null,
			             nome: grupo.nome,
									 grupo: grupo,
									 openSpinner: true
		});
		await this.listarTitulos();
		await this.consultarTitulosPorGrupo(grupo);
		this.setState({modalTitulos: true, openSpinner: false});
	}

	//Preparação para Rodízio
	listarGruposTrabalho = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		await this.grupoTrabalhoService.listarGruposAtivos(usuarioLogado.empresa.codigo)
			.then(response => {
				this.setState({gruposTrabalhoCombo: response.data});
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', 
					               summary: 'Rodízio de Usuários Listagem de Grupos de Trabalho', 
												 detail:`${this.state.detail}`, 
												 life: 4000});
			})
	}

	listarUsuariosPorGrupo = async (grupo) => {
		await this.usuarioGrupoTrabalhoService.listarUsuariosAtivos(grupo)
			.then(response => {
				this.setState({usuarios: response.data});
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', 
					               summary: 'Rodízio de Usuários Listagem de Grupos de Trabalho', 
												 detail:`${this.state.detail}`, 
												 life: 4000});
			})
	}

	rodizio = async (grupoTitulo) => {
		this.setState({openSpinner: true});
		await this.rodizioService.consultarRodizio(this.state.grupo.codigo,grupoTitulo.titulo.codigo)
			.then(response => {
				this.setState({usuariosRodizio: response.data,
					             grupoTitulo: grupoTitulo,
					             tituloNome: grupoTitulo.titulo.titulo,
											 openSpinner: false,
											 modalRodizio: true
				});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
        this.toast.show({severity:'error', 
					               summary: 'Rodízio de Usuários - Usuários', 
												 detail:`${this.state.detail}`, 
												 life: 4000});
			})
	}

	atualizarRodizioUsuarios = async () => {
		await this.rodizioService.consultarRodizio(this.state.grupo.codigo,this.state.grupoTitulo.titulo.codigo)
			.then(response => {
				this.setState({usuariosRodizio: response.data});
			}).catch(error => {	
				this.setState(error.response.data);
				this.toast.show({severity:'error',
				                 summary: 'Rodízio de Usuários - Usuários', 
										   	 detail:`${this.state.detail}`, 
											   life: 4000});
			})
	}

	async onChangeGrupoTrabalho(e) {
		if(e.value === null) {
			this.setState({
				grupoTrabalho: null,
				subGruposUsuarios: {},
				usuarios: [],
				usuario: null
			});
			return;
		}
		this.setState({
			grupoTrabalho: e.value,
			subGruposUsuarios: {},
			usuarios: [],
			usuario: null
		});
		this.setState({openSpinner: true});
		await this.consultarSubGrupos(e.value)
		await this.listarUsuariosPorGrupo(e.value.codigo);
		this.setState({openSpinner: false});
  }

	novoUsuarioRodizio = async () => {
		this.setState({grupoTrabalho: null,
			             usuarios: [],
									 usuario: null,
									 subGruposUsuarios: {},
									 openSpinner: true
		});
		await this.listarGruposTrabalho();
		this.setState({openSpinner: false,
			             modalNovoRodizio: true
		});
	}

	cadastrarUsuarios = async () => {
		if(this.state.usuario === null || this.state.usuario.length === 0) {
			this.toast.show({severity:'error', 
				               summary: 'Rodízio de Usuários', 
											 detail:'Nenhum usuário foi selecionado', 
											 life: 4000});
			return;
		}

		const usuarioSemSubGrupo = this.state.usuario.find(usuario => this.state.subGruposUsuarios[usuario.codigo] === undefined);
		if(usuarioSemSubGrupo !== undefined) {
			this.toast.show({severity:'error', 
				               summary: 'Rodízio de Usuários', 
											 detail:`Informe o Sub-Grupo de Trabalho para ${usuarioSemSubGrupo.nome}`, 
											 life: 4000});
			return;
		}

		var rodizio = [];
		for(let i = 0; i < this.state.usuario.length; i++) {
			const rod = {
				usuario: this.state.usuario[i],
				grupoTrabalho: this.state.grupoTrabalho,
				subGrupoTrabalho: this.state.subGruposUsuarios[this.state.usuario[i].codigo]
			}
			rodizio.push(rod);
		}

		const request = {
			grupo: this.state.grupoTitulo,
			rodizio: rodizio
		}

		this.setState({openSpinner: true});
		await this.rodizioService.incluirRodizio(request)
			.then(response => {
				this.toast.show({severity:'success', 
				                summary: 'Rodízio de Usuários', 
										 	  detail:'Usuário(s) incluído(s) com sucesso', 
											  life: 6000});
				this.setState({openSpinner: false,
				               modalNovoRodizio: false
				});
				this.atualizarRodizioUsuarios();
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
				this.toast.show({severity:'error', 
				                 summary: 'Rodízio de Usuários', 
										   	 detail:`${this.state.detail}`, 
											   life: 4000});
			})
	}

	consultarSubGrupos = async(grupo) => {
    await this.grupoTrabalhoService.listarSubGrupos(grupo.codigo)
      .then(response => {
        this.setState({subGrupoTrabalhoCombo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Rodízio de Usuários', 
					               detail:'Erro ao carregar Sub-Grupos de Trabalho', 
												 life: 4000});
      })
  }

	alterarSubGrupoUsuario = (usuario, subGrupo) => {
		const subGruposUsuarios = {...this.state.subGruposUsuarios};
		if(subGrupo === null) {
			delete subGruposUsuarios[usuario.codigo];
		} else {
			subGruposUsuarios[usuario.codigo] = subGrupo;
		}
		this.setState({subGruposUsuarios: subGruposUsuarios});
	}

	subGrupoUsuarioTemplate = (rowData) => {
		return (
			<div onClick={(e) => e.stopPropagation()}>
				<Dropdown value={this.state.subGruposUsuarios[rowData.codigo]}
									options={this.state.subGrupoTrabalhoCombo}
									style={{width: '100%', height: '32px'}}
									optionLabel="nome"
									emptyMessage=" "
									placeholder="Sub-Grupo de Trabalho"
									filter showClear filterBy="nome"
									onChange={e => this.alterarSubGrupoUsuario(rowData, e.value)}
									id={`idSubGrupoUsuarioCombo${rowData.codigo}`}
									className="p-inputtext-sm p-d-block p-mb-1"/>
			</div>
		);
	}

	acoesRodizioUsuarios(rowData) {
		return (
			<div>
				<Button icon="fa fa-edit" className="p-button-rounded p-button-text"
					onClick={() => this.editarRodizio(rowData)} 
					tooltip="Editar Rodízio" 
					tooltipOptions={{ position: 'top' }}
				/>
				&nbsp;
				<Button icon="pi pi-trash" className="p-button-rounded p-button-text"
					onClick={() => this.confirmacaoExcluirUsuarioRodizio(rowData)} 
					tooltip="Excluir Título" 
					tooltipOptions={{ position: 'top' }}
				/>
			</div>
		);
	}

	editarRodizio = (rodizio) => {
		this.setState({rodizio: rodizio,
									 rodizioNumero: rodizio.rodizio,
									 usuarioNome: rodizio.usuario.nome,
									 modalEditarRodizio: true})				          	
	}

	alterarRodizio = async () => {
		if(this.state.rodizioNumero == '') {
			this.toast.show({severity:'error', summary: 'Rodízio de Usuários', detail:'Informe o número do rodízio', life: 4000});
			return;
		}

		const request = {	
			codigo: this.state.rodizio.codigo,
			rodizio: this.state.rodizioNumero
		}
		this.setState({openSpinner: true});
		await this.rodizioService.alterarRodizio(request)
			.then(response => {
				this.toast.show({severity:'success', summary: 'Rodízio de Usuários', detail:'Rodízio alterado com sucesso', life: 4000});
				this.atualizarRodizioUsuarios();
				this.setState({openSpinner: false, modalEditarRodizio: false});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Rodízio de Usuários', detail:`${this.state.detail}`, life: 4000});
			})
	}

	confirmacaoExcluirUsuarioRodizio(usuario) {
		this.setState({usuarioExcluir: usuario});
		confirmDialog({
				message: 'Deseja realmente excluir o usuário do rodízio ?',
				header: 'Exclusão de Usuário do Rodízio',
				icon: 'pi pi-question-circle',
				acceptClassName: 'p-button-danger',
				acceptLabel: 'Sim',
				rejectLabel: 'Não',
				accept: this.excluirUsuarioRodizio,
				reject: this.reject
		});
	}

	excluirUsuarioRodizio = async () => {
		this.setState({openSpinner: true});
		await this.rodizioService.excluirUsuarioRodizio(this.state.usuarioExcluir.codigo)
			.then(response => {
				this.toast.show({severity:'success', summary: 'Rodízio de Usuários', detail:'Usuário excluído com sucesso', life: 4000});
				this.atualizarRodizioUsuarios();
				this.setState({openSpinner: false});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Rodízio de Usuários', detail:`${this.state.detail}`, life: 4000});
			})
	}

	//Fim de Preparação de Rodízio

	//Títulos
	adicionarTitulo = async () => {
		if(this.state.titulo == null) {
			this.toast.show({severity:'error', summary: 'Grupos de Atividade - Adição de Títulos', detail:'Informe o título de atividade', life: 4000});
			return;
		}

		if(this.state.prazo == '') {
			this.toast.show({severity:'error', summary: 'Grupos de Atividade - Adição de Títulos', detail:'Informe o prazo da atividade', life: 4000});
			return;
		}

		this.setState({openSpinner: true});
		const gat = {
			grupo: this.state.grupo,
			titulo: this.state.titulo,
			prazo: this.state.prazo,
			prazoFatal: this.state.prazoFatal
		}

		await this.grupoAtividadeTituloService.adicionar(gat)
			.then(response => {
				this.toast.show({severity:'success', summary: 'Grupos de Atividade - Adição de Títulos', 
					               detail:'Título adicionado com sucesso', life: 4000});
				this.atualizarTitulosPorGrupo();
				this.setState({openSpinner: false, titulo: null, prazo: ''});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade - Adição de Títulos', detail:`${this.state.detail}`, life: 4000});
			})
	}

	listarTitulos = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		await this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
			.then(response => {
				this.setState({titulosCombo: response.data});
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade - Listagem de Títulos - Combo', detail:`${this.state.detail}`, life: 4000});
			})
	}

	consultarTitulosPorGrupo = async (grupo) => {
		this.setState({openSpinner: true});
		await this.grupoAtividadeTituloService.consultarPorGrupo(grupo.codigo)
			.then(response => {
				this.setState({titulos: response.data,
										 	 modalTitulos: true,
											 openSpinner: false
				});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade - Listagem de Títulos', detail:`${this.state.detail}`, life: 4000});
			})
	}

	atualizarTitulosPorGrupo = async () => {
		await this.grupoAtividadeTituloService.consultarPorGrupo(this.state.grupo.codigo)
			.then(response => {
				this.setState({titulos: response.data});
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade - Listagem de Títulos', detail:`${this.state.detail}`, life: 4000});
			})
	}

	editarPrazos = (titulo) => {
		this.setState({atividadeGrupoTitulo: titulo,
			            prazoEditar: titulo.prazo,
									prazoFatalEditar: titulo.prazoFatal,
									tituloNome: titulo.titulo.titulo,
							   	modalEditarTitulo: true});

	  var flags = [];									
		flags.push(titulo.importante === 'SIM' ? 'S' : 'N');
		flags.push(titulo.urgente === 'SIM' ? 'S' : 'N');
		flags.push(titulo.privado === 'SIM' ? 'S' : 'N');
		this.setState({flagsEditar: flags});
	}

	alterarPrazos = async () => {
		if(this.state.prazoEditar == '') {
			this.toast.show({severity:'error', summary: 'Grupos de Atividade - Alteração de Prazos', detail:'Informe o prazo da atividade', life: 4000});
			return;
		}

		const request = {
			codigo: this.state.atividadeGrupoTitulo.codigo,
			prazo: this.state.prazoEditar,
			prazoFatal: this.state.prazoFatalEditar,
			importante: this.state.flagsEditar[0],
			urgente: this.state.flagsEditar[1],
			privado: this.state.flagsEditar[2]
		}

		this.setState({openSpinner: true});
		await this.grupoAtividadeTituloService.alterar(request)
			.then(response => {
				this.atualizarTitulosPorGrupo();
				this.toast.show({severity:'success', summary: 'Grupos de Atividade - Alteração de Prazos', 
					               detail:'Prazo alterado com sucesso', life: 4000});
				this.setState({openSpinner: false});
				this.fecharModal('modalEditarTitulo');
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade - Alteração de Prazos', detail:`${this.state.detail}`, life: 4000});
			})
	}

	acoesTitulos(rowData) {
		return (
			<React.Fragment>
				
				<Button icon="fa fa-edit" className="p-button-rounded p-button-text"
					onClick={() => this.editarPrazos(rowData)}
					tooltip="Alterar Prazo" 
					tooltipOptions={{ position: 'top' }}
				/>

				&nbsp;

				<span style={{ position: 'relative', display: 'inline-block' }}>
					<Button icon="fa fa-users-cog" className="p-button-rounded p-button-text"
						onClick={() => this.rodizio(rowData)} 
						tooltip="Rodízio de Usuários" 
						tooltipOptions={{ position: 'top' }}
					/>

					{rowData.usuarios > 0 && (
						<Badge 
							value={rowData.usuarios > 99 ? '99+' : rowData.usuarios}
							severity="danger"
							style={{
								position: 'absolute',
								top: '2px',
								right: '2px',
								transform: 'translate(30%, -30%)',
								fontSize: '9px',
								minWidth: '16px',
								height: '16px',
								lineHeight: '16px',
								padding: '0',
								borderRadius: '50%'
							}}
						/>
					)}
				</span>

				&nbsp;

				<Button icon="pi pi-trash" className="p-button-rounded p-button-text"
					onClick={() => this.confirmacaoExclusaoTitulos(rowData)} 
					tooltip="Excluir Título" 
					tooltipOptions={{ position: 'top' }}
				/>

			</React.Fragment>
		);
	}

	confirmacaoExclusaoTitulos(titulo) {
		this.setState({tituloExcluir: titulo.titulo});
		confirmDialog({
				message: 'Deseja realmente excluir o título selecionado ?',
				header: 'Exclusão de Título',
				icon: 'pi pi-question-circle',
				acceptClassName: 'p-button-danger',
				acceptLabel: 'Sim',
				rejectLabel: 'Não',
				accept: this.excluirTitulo,
				reject: this.reject
		});
	}

	excluirTitulo = async () => {
		this.setState({openSpinner: true});
		await this.grupoAtividadeTituloService.excluir(this.state.tituloExcluir.codigo,this.state.grupo.codigo)
			.then(response => {
				this.atualizarTitulosPorGrupo();
				this.toast.show({severity:'success', 
					               summary: 'Grupos de Atividade - Exclusão de Títulos', 
												 detail:'Atividade excluída com sucesso', 
												 life: 4000});
				this.setState({openSpinner: false});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade - Exclusão de Atividades', detail:`${this.state.detail}`, life: 4000});
			})
	}

	//Fim de títulos

	renderFooterCadastrarGrupo(name) {
		return (
			<div>
				<Button label="Cadastrar" 
								className="p-button-primary p-button-text"
								onClick={this.cadastrar}/> 
				&nbsp;
				<Button label="Cancelar" 
								className="p-button-secondary p-button-text"
								onClick={() => this.fecharModal(name)}/>
			</div>
		);
	}

	renderFooterAlterarGrupo(name) {
		return (
			<div>
				<Button label="Alterar" 
								className="p-button-primary p-button-text"
								onClick={this.cadastrar}/> 
				&nbsp;
				<Button label="Cancelar" 
								className="p-button-secondary p-button-text"
								onClick={() => this.fecharModal(name)}/>
			</div>
		);
	}

	editarGrupo = (grupo) => {
		this.setState({grupo: grupo, 
			            nome: grupo.nome, 
									codigo: grupo.codigo, 
									modalGrupoAlterar: true});
	}

	fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

	novoGrupo = () => {
		this.setState({nome: '', modalGrupo: true});
	}

	listar = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		await this.grupoAtividadeService.listar(usuarioLogado.empresa.codigo)
			.then(response => {
				this.setState({grupos: response.data});
			}).catch(error => {
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade', detail:`${this.state.detail}`, life: 4000});
			})
	}

	cadastrar = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		this.setState({openSpinner: true});
		if(this.state.nome == '') {
			this.toast.show({severity:'error', summary: 'Grupos de Atividade', detail:'Informe o nome do grupo', life: 4000});
			return;
		}
		const grupo = {
			nome: this.state.nome,
			usuario: usuarioLogado
		}
		await this.grupoAtividadeService.cadastrar(grupo)
			.then(response => {
				this.setState({openSpinner: false, modalGrupo: false});
				this.listar();
				this.toast.show({severity:'success', summary: 'Grupos de Atividade', detail:'Grupo de atividade cadastrado com sucesso', life: 4000});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade', detail:`${this.state.detail}`, life: 4000});
			})
	}

	acoes(rowData) {
			return(
				<React.Fragment>
					<Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
									onClick={() => this.editarGrupo(rowData)}
									tooltip="Editar Grupo" 
									tooltipOptions={{position: 'top'}} />
					&nbsp;
					<Button icon="pi pi-sitemap" 
					        className="p-button-rounded p-button-text"
									onClick={() => this.novoTitulo(rowData)}
									tooltip="Consultar atividades do grupo" 
									tooltipOptions={{position: 'top'}}/>
					&nbsp;
					<Button icon="pi pi-trash" className="p-button-rounded p-button-text"
									onClick={() => this.confirmacaoExclusaoGrupoAtividade(rowData)} 
									tooltip="Excluir Grupo" 
									tooltipOptions={{position: 'top'}}/>
				</React.Fragment>
			);
	}

	confirmacaoExclusaoGrupoAtividade(grupo) {
		this.setState({grupo: grupo});
		confirmDialog({
				message: 'Deseja realmente excluir o grupo de atividade selecionado?',
				header: 'Exclusão de grupo de atividade',
				icon: 'pi pi-question-circle',
				acceptClassName: 'p-button-danger',
				acceptLabel: 'Sim',
				rejectLabel: 'Não',
				accept: this.excluirGrupoAtividade,
				reject: this.reject
		});
	}

	excluirGrupoAtividade = async () => {
		this.setState({openSpinner: true});
		await this.grupoAtividadeService.excluir(this.state.grupo.codigo)
			.then(response => {
				this.toast.show({severity:'success', summary: 'Grupos de Atividade', detail:'Grupo de Atividade excluído com sucesso', life: 4000});
				this.listar();
				this.setState({openSpinner: false});
			}).catch(error => {
				this.setState({openSpinner: false});
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Atividade', detail:`${this.state.detail}`, life: 4000});
			})
	}

	async componentDidMount() {
		this.setState({openSpinner: true});
		await this.listar();
		this.setState({openSpinner: false});
	}

	render() {
		return(
			<>
				<NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
					{/**Cadastrar Grupo de Atividades */}
					<Dialog header="Cadastrar Grupo de Atividade"
										visible={this.state.modalGrupo} 
										style={{ width: '40vw' }} 
										footer={this.renderFooterCadastrarGrupo('modalGrupo')} 
										onHide={() => this.fecharModal('modalGrupo')}>
								
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
										 <label htmlFor="nomeGrupo">Nome do Grupo</label>
										 <InputText id="nomeGrupo" 
																type="text"
																style={{width: '100%', height: '32px'}} 
																value={this.state.nome}
																onChange={e => this.setState({nome: e.target.value})}
																placeholder="Nome do Grupo"
																className="p-inputtext-sm p-d-block p-mb-1"/>
										</div>
									</div>
								</div>
					</Dialog>
					{/**Editar Grupo de Atividades */}
					<Dialog header="Editar Grupo de Atividade"
										visible={this.state.modalGrupoAlterar} 
										style={{ width: '40vw' }} 
										footer={this.renderFooterAlterarGrupo('modalGrupoAlterar')} 
										onHide={() => this.fecharModal('modalGrupoAlterar')}>
								
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
										 <label htmlFor="nomeGrupo">Nome do Grupo</label>
										 <InputText id="nomeGrupo" 
																type="text"
																style={{width: '100%', height: '32px'}} 
																value={this.state.nome}
																onChange={e => this.setState({nome: e.target.value})}
																placeholder="Nome do Grupo"
																className="p-inputtext-sm p-d-block p-mb-1"/>
										</div>
									</div>
								</div>
					</Dialog>
					{/**Adicionar novo título */}
					<Dialog header="Adicionar títulos de atividade ao grupo"
										visible={this.state.modalTitulos} 
										style={{ width: '40vw' }} 
										footer={
											<div>
													<Button label="Fechar" 
																	className="p-button-secondary p-button-text"
																	onClick={() => this.fecharModal('modalTitulos')}/>
											</div>
										} 
										onHide={() => this.fecharModal('modalTitulos')}>
								
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
										 	<strong>Grupo de Atividade:</strong> &nbsp;
											<strong style={{color: 'blue'}}>{this.state.nome}</strong>
										</div>
									</div>
								</div>
								<br></br>
								<div className="row">
									<div className="col-md-6">
										<div className="formGroup">
											<Dropdown value={this.state.titulo} 
																options={this.state.titulosCombo} 
																style={{width: '100%', height: '32px'}}
																optionLabel="titulo" 
																emptyMessage=" "
																placeholder="Título"
																filter showClear filterBy="titulo"
																onChange={e => this.setState({titulo: e.target.value})}
																id="idTituloCombo"
																className="p-inputtext-sm p-d-block p-mb-1"/>				
										</div>
									</div>
									<div className="col-md-3">
										<div className="formGroup">
											<InputText
													inputId="idPrazo"
													value={this.state.prazo}
													onChange={(e) => {
															let valor = e.target.value;
															// remove tudo que não for número
															valor = valor.replace(/\D/g, '');
															// limita a 2 caracteres
															valor = valor.slice(0, 2);
															this.setState({ prazo: valor });
													}}
													style={{ width: '100%', height: '32px' }}
													placeholder="Prazo"
											/>
										</div>
									</div>
									<div className="col-md-3">
										<div className="formGroup">
											<InputText
													inputId="idPrazoFatal"
													value={this.state.prazoFatal}
													onChange={(e) => {
															let valor = e.target.value;
															// remove tudo que não for número
															valor = valor.replace(/\D/g, '');
															// limita a 2 caracteres
															valor = valor.slice(0, 2);
															this.setState({ prazoFatal: valor });
													}}
													style={{ width: '100%', height: '32px' }}
													placeholder="Prazo Fatal"
											/>
										</div>
									</div>
							</div>
							<br></br>
							<div className="row">
								<div className="col-md-12">
									<div className="formGroup" style={{ display: 'flex', gap: '20px' }}>
										<div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
											<Checkbox inputId="importante"
												checked={this.state.flags[0] === 'S'}
												onChange={(e) => {
													let newFlags = [...this.state.flags];
													newFlags[0] = e.checked ? 'S' : 'N';
													this.setState({ flags: newFlags });
												}}
											/>
											<label htmlFor="importante">Importante</label>
										</div>

										<div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
											<Checkbox inputId="urgente"
												checked={this.state.flags[1] === 'S'}
												onChange={(e) => {
													let newFlags = [...this.state.flags];
													newFlags[1] = e.checked ? 'S' : 'N';
													this.setState({ flags: newFlags });
												}}
											/>
											<label htmlFor="urgente">Urgente</label>
										</div>

										<div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
											<Checkbox inputId="privado"
												checked={this.state.flags[2] === 'S'}
												onChange={(e) => {
													let newFlags = [...this.state.flags];
													newFlags[2] = e.checked ? 'S' : 'N';
													this.setState({ flags: newFlags });
												}}
											/>
											<label htmlFor="privado">Privado</label>
										</div>

									</div>
								</div>
							</div>
							<br></br>
							<div className="row">
								<div className="col-md-12">
									<div className="formGroup">
										<button type="button" className="btn btn-primary bg-gradient-primary"
										                style={{width: '100%', height: '32px'}}  
																		onClick={this.adicionarTitulo}>
										<i class="fas fa-plus"></i> Adicionar</button>
									</div>
								</div>
							</div>
							<br></br>
							<br></br>
							<div className="row">
								<div className="col-md-12">
									<div className="formGroup">
										<DataTable value={this.state.titulos}
											         size="small"
												       emptyMessage="Nenhum título cadastrado">
												<Column field="titulo.titulo" header="Nome"></Column>
												<Column field="prazo" header="Prazo"></Column>
												<Column field="prazoFatal" header="Prazo Fatal"></Column>
												<Column field="importante" header="Importante"></Column>
												<Column field="urgente" header="Urgente"></Column>
												<Column field="privado" header="Privado"></Column>
												<Column body={this.acoesTitulos} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
											</DataTable>
									</div>
								</div>
							</div>
					</Dialog>

					{/**Alterar os dados de configurações dos títulos */}
					<Dialog header="Editar configurações do título"
										visible={this.state.modalEditarTitulo} 
										style={{ width: '40vw' }} 
										footer={
											<div>
													<Button label="Alterar" 
																	className="p-button-success p-button-text"
																	onClick={this.alterarPrazos}/>
													&nbsp;
													<Button label="Fechar" 
																	className="p-button-secondary p-button-text"
																	onClick={() => this.fecharModal('modalEditarTitulo')}/>
											</div>
										} 
										onHide={() => this.fecharModal('modalEditarTitulo')}>
								
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
										 	<strong>Título:</strong> &nbsp;
											<strong style={{color: 'blue'}}>{this.state.tituloNome}</strong>
										</div>
									</div>
								</div>
								<br></br>
								<div className="row">
									<div className="col-md-6">
										<div className="formGroup">
											<InputText
													inputId="idPrazoEditar"
													value={this.state.prazoEditar}
													onChange={(e) => {
															let valor = e.target.value;
															// remove tudo que não for número
															valor = valor.replace(/\D/g, '');
															// limita a 2 caracteres
															valor = valor.slice(0, 2);
															this.setState({ prazoEditar: valor });
													}}
													style={{ width: '100%', height: '32px' }}
													placeholder="Prazo"
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="formGroup">
											<InputText
													inputId="idPrazoFatalEditar"
													value={this.state.prazoFatalEditar}
													onChange={(e) => {
															let valor = e.target.value;
															// remove tudo que não for número
															valor = valor.replace(/\D/g, '');
															// limita a 2 caracteres
															valor = valor.slice(0, 2);
															this.setState({ prazoFatalEditar: valor });
													}}
													style={{ width: '100%', height: '32px' }}
													placeholder="Prazo Fatal"
											/>
										</div>
									</div>
								</div>
								<br></br>
							<div className="row">
								<div className="col-md-12">
									<div className="formGroup" style={{ display: 'flex', gap: '20px' }}>
										<div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
											<Checkbox inputId="importanteEditar"
												checked={this.state.flagsEditar[0] === 'S'}
												onChange={(e) => {
													let newFlags = [...this.state.flagsEditar];
													newFlags[0] = e.checked ? 'S' : 'N';
													this.setState({ flagsEditar: newFlags });
												}}
											/>
											<label htmlFor="importante">Importante</label>
										</div>

										<div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
											<Checkbox inputId="urgenteEditar"
												checked={this.state.flagsEditar[1] === 'S'}
												onChange={(e) => {
													let newFlags = [...this.state.flagsEditar];
													newFlags[1] = e.checked ? 'S' : 'N';
													this.setState({ flagsEditar: newFlags });
												}}
											/>
											<label htmlFor="urgente">Urgente</label>
										</div>

										<div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
											<Checkbox inputId="privadoEditar"
												checked={this.state.flagsEditar[2] === 'S'}
												onChange={(e) => {
													let newFlags = [...this.state.flagsEditar];
													newFlags[2] = e.checked ? 'S' : 'N';
													this.setState({ flagsEditar: newFlags });
												}}
											/>
											<label htmlFor="privado">Privado</label>
										</div>

									</div>
								</div>
							</div>
					</Dialog>

					{/**Rodízio */}
					<Dialog header="Rodízio de Usuários"
										visible={this.state.modalRodizio} 
										style={{ width: '40vw' }} 
										footer={
											<div>
													<Button label="Incluir Usuários" 
																	className="p-button-success p-button-text"
																	onClick={this.novoUsuarioRodizio}/>
													&nbsp;
													<Button label="Fechar" 
																	className="p-button-secondary p-button-text"
																	onClick={() => this.fecharModal('modalRodizio')}/>
											</div>
										} 
										onHide={() => this.fecharModal('modalRodizio')}>
								
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
											<strong style={{color: 'blue'}}>{this.state.nome} / {this.state.tituloNome}</strong>
										</div>
									</div>
								</div>
								<br></br>
								<DataTable value={this.state.usuariosRodizio}
									size="small"
									emptyMessage="Nenhum usuário encontrado">
									<Column field="usuario.nome" header="Usuário"></Column>
									<Column field="grupoTrabalho.nome" header="Grupo de Traballho"></Column>
									<Column field="subGrupoTrabalho.nome" header="Sub-Grupo de Traballho"></Column>
									<Column field="rodizio" header="Rodízio"></Column>
									<Column body={this.acoesRodizioUsuarios} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
								</DataTable>
					</Dialog>

					{/**Incluir usuários no rodízio */}
					<Dialog header="Rodízio de Usuários"
										visible={this.state.modalNovoRodizio} 
										style={{ width: '55vw' }} 
										footer={
											<div>
													<Button label="Cadastrar" 
																	className="p-button-success p-button-text"
																	onClick={this.cadastrarUsuarios}/>
													&nbsp;
													<Button label="Fechar" 
																	className="p-button-secondary p-button-text"
																	onClick={() => this.fecharModal('modalNovoRodizio')}/>
											</div>
										} 
										onHide={() => this.fecharModal('modalNovoRodizio')}>
								
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
											<strong style={{color: 'blue'}}>{this.state.nome} / {this.state.tituloNome}</strong>
										</div>
									</div>
								</div>
								<br></br>
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
											<Dropdown value={this.state.grupoTrabalho} 
																options={this.state.gruposTrabalhoCombo} 
																style={{width: '100%', height: '32px'}}
																optionLabel="nome" 
																emptyMessage=" "
																placeholder="Grupo de Trabalho"
																filter showClear filterBy="nome"
																onChange={this.onChangeGrupoTrabalho}
																id="idGrupoCombo"
																className="p-inputtext-sm p-d-block p-mb-1"/>
										</div>
									</div>
								</div>
								<br></br>
								<DataTable value={this.state.usuarios}
									selection={this.state.usuario} 
									size="small"
									onSelectionChange={(e) => this.setState({ usuario: e.value })}
									emptyMessage="Nenhum usuário encontrado">
									<Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
									<Column field="nome" header="Usuário"></Column>
									<Column body={this.subGrupoUsuarioTemplate} header="Sub-Grupo de Trabalho" style={{ minWidth: '18rem' }}></Column>
								</DataTable>
					</Dialog>

					{/**Alterar Rodízio */}
					<Dialog header="Editar Rodízio"
										visible={this.state.modalEditarRodizio} 
										style={{ width: '40vw' }} 
										footer={
											<div>
													<Button label="Alterar" 
																	className="p-button-success p-button-text"
																	onClick={this.alterarRodizio}/>
													&nbsp;
													<Button label="Fechar" 
																	className="p-button-secondary p-button-text"
																	onClick={() => this.fecharModal('modalEditarRodizio')}/>
											</div>
										} 
										onHide={() => this.fecharModal('modalEditarRodizio')}>
								
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
											<strong style={{color: 'blue'}}>{this.state.usuarioNome}</strong>
										</div>
									</div>
								</div>
								<br></br>
								<div className="row">
									<div className="col-md-12">
										<div className="formGroup">
											<label htmlFor="rodizioEditar">Rodízio</label>	
											<InputText Id="rodizioEditar"
												value={this.state.rodizioNumero}
												onChange={e => this.setState({rodizioNumero: e.target.value})}
												style={{ width: '100%', height: '32px' }}
												placeholder="Rodízio"
											/>
										</div>
									</div>
								</div>
					</Dialog>
					
					<section className="content-header">
            <div className="container-fluid">
							<div className="row">
									<div className="col-md-12">
										<div className="card card-primary card-outline">
											<div className="card-header">
												<h3 className="card-title">
													<i class="fa fa-object-ungroup"></i>
													<span> Grupos de Atividade</span>
												</h3>  
											</div>
											<div className="card-body">
												<div className="row">
													<div className="col-md-5">
														<span className="input-group">
															<button type="button" className="btn btn-primary bg-gradient-primary" 
																			onClick={this.novoGrupo}>
															<i class="fas fa-plus"></i> Adicionar</button>
														</span>
													</div>
												</div>
											</div>
											<DataTable value={this.state.grupos}  paginator responsiveLayout="scroll"
											           size="small"
												paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
												emptyMessage="Nenhum grupo cadastrado"
												currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
												<Column field="nome" header="Nome"></Column>
												<Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
											</DataTable>
										</div>
									</div>
								</div>
							</div>
						</section>
				</div>
			</>
		);
	}
}

GrupoAtividade.contextType = AuthContext;
export default withRouter (GrupoAtividade)
